<template>
  <div id="page-user-view">
    <vs-alert
      color="danger"
      title="ユーザーが見つかりません"
      :active.sync="hasError"
    >
      <span>ユーザID: {{ $route.params.userId }} </span>
    </vs-alert>

    <div id="user-data">
      <!-- 基本情報 -->
      <card-user-basic-info />
      <!-- 免許・資格 -->
      <card-user-license />
    </div>
  </div>
</template>

<script>
import CardUserBasicInfo from "./cards/cardUserBasicInfo";
import CardUserLicense from "./cards/cardUserLicense";

import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("enterpriseUserView");

export default {
  components: {
    CardUserBasicInfo,
    CardUserLicense
  },
  data() {
    return {
      userId: null,
      userData: null,
      showUserData: false,
      userLicenseData: null,
      avatarText: "",
      hasError: false
    };
  },
  computed: {
    ...mapState({
      user: state => state.user,
      licenses: state => state.licenses
    })
  },
  methods: {
    ...mapActions(["fetchViewData", "resetEnterpriseUserViewState"]),

    cleanup() {
      this.resetEnterpriseUserViewState();
    }
  },
  async created() {
    await this.fetchViewData(this.$route.params.userId);
  },
  beforeDestroy() {
    this.cleanup();
  }
};
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
</style>
